function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("style", null, ".cls-1{fill:#075da9;}"));

var _ref3 =
/*#__PURE__*/
React.createElement("title", null, "Product Icons");

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M63,61.49H60.47v-38a1,1,0,0,0-1-1H51.33a1,1,0,0,0-1,1v38H44.86V41.65a1,1,0,0,0-1-1H35.72a1,1,0,0,0-1,1V61.49H29.26v-25a1,1,0,0,0-1-1H20.12a1,1,0,0,0-1,1v25H13.65v-12a1,1,0,0,0-1-1H4.51a1,1,0,0,0-1,1v12H1a1,1,0,1,0,0,1.95H63a1,1,0,1,0,0-1.95ZM52.31,24.43h6.2V61.49h-6.2ZM36.7,42.63h6.2V61.49H36.7ZM21.1,37.46h6.2v24H21.1Zm-15.61,13h6.2V61.49H5.49ZM8.59,36A4.67,4.67,0,0,0,12.69,29l8.53-7.17a4.61,4.61,0,0,0,3,1.1,4.66,4.66,0,0,0,4.09-2.45L35.16,23a3.75,3.75,0,0,0,0,.47,4.69,4.69,0,0,0,9.38,0,4.61,4.61,0,0,0-1.08-3L53.17,9.34a4.6,4.6,0,0,0,2.24.6,4.69,4.69,0,1,0-4.69-4.69,4.65,4.65,0,0,0,1,2.81l-9.8,11.21a4.57,4.57,0,0,0-2.08-.51,4.67,4.67,0,0,0-4,2.35l-6.91-2.5c0-.12,0-.24,0-.36a4.69,4.69,0,0,0-9.38,0A4.56,4.56,0,0,0,20,20.3l-8.59,7.23a4.64,4.64,0,0,0-2.82-1,4.69,4.69,0,0,0,0,9.38ZM55.41,2.51a2.74,2.74,0,1,1-2.73,2.74A2.74,2.74,0,0,1,55.41,2.51ZM39.8,20.72a2.78,2.78,0,1,1-2.61,2h0v0A2.74,2.74,0,0,1,39.8,20.72Zm-15.6-5.2a2.69,2.69,0,0,1,2.64,3.38v0a2.73,2.73,0,1,1-2.63-3.42Zm-15.61,13a2.74,2.74,0,0,1,2,.93h0a2.7,2.7,0,0,1,.68,1.79,2.73,2.73,0,1,1-2.73-2.74Z"
});

var SvgAnalyticsIcon = function SvgAnalyticsIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 64 64",
    ref: svgRef
  }, props), _ref2, title === undefined ? _ref3 : title ? React.createElement("title", null, title) : null, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgAnalyticsIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/analytics-icon.3f4943dd.svg";
export { ForwardRef as ReactComponent };